module.exports = __webpack_public_path__ + "static/media/Colortech_location.3c0dbf23.png";